<template>
  <div>
    <v-autocomplete
      :items="Campaign"
      outlined
      rounded
      dense @change="$emit('change', selectedCampaign)"
      hide-details auto-select-first
      :loading="loading"
      label="Select Campaign"
      single-line
      item-text="name"
      return-object
      v-model="selectedCampaign"
    >
      <template slot="item" slot-scope="{ item }">
        <span>{{ item.name }}</span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import campaignService from "@/modules/Campaign/service.js";

export default {
  props: {
    initValue: {
      default: null,
    },
  },
  data() {
    return {
      Campaign: [],
      loading: false,
      selectedCampaign: null,
    };
  },
  watch: {
    selectedCampaign(val) {
      if (val) {
        this.$emit("input", val);
        this.$emit("reset");
      }
    },
    initValue(val) {
      console.log('init for campaing', val)
      this.selectedCampaign = val;
    },
  },
  async created() {
    await this.getList();
    if (this.initValue) {
      this.selectedCampaign = this.initValue;
    }
  },
  methods: {
    getList() {
      this.loading = true;
      return campaignService.getAll().then((response) => {
        this.loading = false;
        this.Campaign = response.data;
        return response;
      });
    },
  },
};
</script>

<style scoped></style>
